import script from "./tabPaneConrtent.vue?vue&type=script&setup=true&lang=js"
export * from "./tabPaneConrtent.vue?vue&type=script&setup=true&lang=js"

import "./tabPaneConrtent.vue?vue&type=style&index=0&id=e58e953e&scoped=true&lang=less"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e58e953e"]])

export default __exports__